module.exports = __webpack_public_path__ + "media/signup-react/Calendar-ba2ec3a2.svg";